import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  startTestContainer: {
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
  },

  countDownTimerContainer: {
    height: '100%',
    width: '100%',
  },

  countDownTimer: {
    fontSize: '20px',
  },

  time: {
    fontWeight: 600,
  },

  quizEnded: {
    fontSize: '24px',
  },

  nameTextFieldWrapper: {
    border: `solid 1px ${theme?.palette?.borders?.main}`,
    borderRadius: 4,
    padding: '0 0 0 15px',
    height: '100%',
  },

  nameTextField: {
    height: '46px',
    padding: 0,
  },

  continueButton: {
    fontWeight: 600,
    background: theme?.palette?.primaryButton?.main,
    color: theme?.palette?.primaryButton?.contrastText,
    height: '100%',
    width: '104px',
    borderRadius: '5px',
    '&:hover': {
      background: theme?.palette?.primaryButton?.hover,
    },
  },

  publicQuizOnboardingPage: {
    width: '100%',
    height: '100%',
  },

  inputName: {
    height: '100%',
    width: 'calc(100% - 114px)',
    marginRight: '10px',
  },

  userNameLoader: {
    color: 'whitesmoke',
  },

  quizOnBoardingPage: {
    height: '100%',
    width: '100%',
  },

  loginButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

  signingIn: {
    textAlign: 'center',
    padding: '1rem',
    color: '#555',
    fontSize: '14px',
  },

  msalError: {
    margin: 0,
    fontSize: '13px',
    color: '#d93025',
    lineHeight: '1.5',
  },

  microsoftButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '240px',
    height: '40px',
    backgroundColor: '#fff',
    border: '1px solid #dadce0',
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    fontFamily: 'Roboto, Arial, sans-serif',
    fontSize: '14px',
    color: '#3c4043',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      backgroundColor: '#f7f8f8',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    },
  },
}))

export { useStyles }
